import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Rx';
import { EventManager , JhiLanguageService  } from 'ng-jhipster';

import { Testentity } from './testentity.model';
import { TestentityService } from './testentity.service';

@Component({
    selector: 'jhi-testentity-detail',
    templateUrl: './testentity-detail.component.html'
})
export class TestentityDetailComponent implements OnInit, OnDestroy {

    testentity: Testentity;
    private subscription: any;
    private eventSubscriber: Subscription;

    constructor(
        private eventManager: EventManager,
        private jhiLanguageService: JhiLanguageService,
        private testentityService: TestentityService,
        private route: ActivatedRoute
    ) {
        this.jhiLanguageService.setLocations(['testentity']);
    }

    ngOnInit() {
        this.subscription = this.route.params.subscribe((params) => {
            this.load(params['id']);
        });
        this.registerChangeInTestentities();
    }

    load(id) {
        this.testentityService.find(id).subscribe((testentity) => {
            this.testentity = testentity;
        });
    }
    previousState() {
        window.history.back();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.eventManager.destroy(this.eventSubscriber);
    }

    registerChangeInTestentities() {
        this.eventSubscriber = this.eventManager.subscribe('testentityListModification', (response) => this.load(this.testentity.id));
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/testentity/testentity-detail.component.ts